import React from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LaneRatesEditor from './LaneRatesEditor';
function isAddAction(location) {
    return location.pathname.includes('add');
}
export default function LaneRatesEditPage() {
    var _a;
    const { t } = useTranslation();
    const location = useLocation();
    const isActionCreate = isAddAction(location);
    const breadcrumbs = {
        pages: [
            {
                name: t('LANE_RATES'),
                href: '/lane-rates',
                current: false,
            },
            {
                name: isActionCreate ? t('ADD_LANE_RATE') : t('EDIT_LANE_RATES'),
                current: true,
            },
        ],
    };
    return (React.createElement("main", { className: "py-4" },
        React.createElement(LayoutWithSidebar, { title: t('LANE_RATES'), breadcrumbs: breadcrumbs },
            React.createElement(LaneRatesEditor, { laneRates: (_a = location.state) === null || _a === void 0 ? void 0 : _a.laneRates, isActionCreate: isActionCreate }))));
}
